import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  getSignificantPoint(significantPointID) {
    return axios
      .get(`${URL}/participant_data/significant_points/${significantPointID}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  createSignificantPoint(payload) {
    return axios
      .post(`${URL}/participant_data/significant_points`, { ...payload })
      .then((res) => {
        return res.data;
      });
  },
  updateSignificantPoint(significantPointID, payload) {
    return axios
      .patch(
        `${URL}/participant_data/significant_points/${significantPointID}`,
        { ...payload }
      )
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  deleteSignificantPoint(significantPointID) {
    return axios
      .delete(`${URL}/participant_data/significant_points/${significantPointID}`)
      .then((res) => {
        return res;
      });
  },
};
